import { useCallback, useMemo } from 'react';

import { NEW_NOTIFICATION_SOUND } from './constants';

/**
 * The same behavior as telescope's useNotifications: one Audio element per
 * mount, and a play() that swallows the autoplay rejection browsers throw
 * before the agent has interacted with the page.
 */
const useNotificationSound = (): (() => void) => {
  const audio = useMemo(() => new Audio(NEW_NOTIFICATION_SOUND), []);

  return useCallback(() => {
    void audio.play().catch(() => undefined);
  }, [audio]);
};

export default useNotificationSound;
